export function getDeviceType(): "mobile" | "desktop" {
  const ua = navigator.userAgent;
  return /Android|iPhone|iPad|iPod/i.test(ua) ? "mobile" : "desktop";
}

export function isMobileDevice(): boolean {
  return getDeviceType() === "mobile";
}
